import { useState } from "react";
import { motion, useSpring } from "framer-motion";
import "./Cards.css";
import { redirect } from "react-router-dom";
export default function Cards(props) {
  var [a, b] = useState(true);
  var variant = {
    show: {
      scale: [0.4, 0.9, 1.4, 1.8, 2, 1.6, 1],
      backgroundColor: [
        "hsl(210, 75, 52)",
        "hsl(305, 87, 53)",
        "hsl(46, 85, 60)"
      ],
      rotateY: 360,
      transition: {
        duration: 0.4
      }
    },
    hide: {
      scale: 0.2
    }
  };
  function doing() {
    b(!a);
    console.log(a);
  }
  var Front = (props) => {
    return (
      <>
        <div data-aos="fade-right" className="cards" onClick={doing}>
          <img
            src="https://underconstructionpage.com/wp-content/uploads/2018/12/crello.png"
            width="200px"
            alt={props.name}
          />
          <h2 style={{ textAlign: "center" }}>{props.name}</h2>
        </div>
      </>
    );
  };
  var Back = () => {
    return (
      <motion.div
        variants={variant}
        initial="hide"
        animate="show"
        className="cards"
        onClick={doing}
      >
        <h1>Something</h1>
      </motion.div>
    );
  };
  return (
    <div className="dadichod">{a ? <Front name={props.name} /> : <Back />}</div>
  );
}
